import React from 'react';
import Menu from './Components/menu';
import Features from './Components/features';
import Precos from './Components/precos';
import Footer from '../comum/Footer';
import './Components/site.css';

function Site() {
  return (
    <div className="site-wrapper">
      <Menu />
      <main style={{ paddingTop: '80px' }}>
        <Features />
        <Precos />
      </main>
      <Footer />
    </div>
  );
}

export default Site;